@if (downloads.hasDownloads()) {
  <aside class="download-overlay" [class.is-collapsed]="!downloads.expanded()" aria-label="Local AI model downloads">
    <button type="button" class="download-overlay-head" (click)="downloads.toggleExpanded()" [attr.aria-expanded]="downloads.expanded()">
      <span class="download-icon" aria-hidden="true"><i class="fas fa-download"></i></span>
      <span class="download-heading">
        <strong>Model downloads</strong>
        <small>{{ downloads.summary() }}</small>
      </span>
      <span class="download-count" *ngIf="downloads.activeCount()">{{ downloads.activeCount() }}</span>
      <i class="fas" [class.fa-chevron-down]="downloads.expanded()" [class.fa-chevron-up]="!downloads.expanded()" aria-hidden="true"></i>
    </button>

    @if (downloads.expanded()) {
      <div class="download-list">
        @for (task of downloads.tasks(); track task.id) {
          <article class="download-item" [attr.data-status]="task.status">
            <div class="download-item-row">
              <span>
                <strong>{{ task.category }}</strong>
                <small>{{ progressLabel(task) }}</small>
              </span>
              @if (canCancel(task)) {
                <button type="button" class="cancel-download" (click)="downloads.cancel(task.id); $event.stopPropagation()" [attr.aria-label]="'Cancel ' + task.category + ' download'" title="Cancel download">
                  <i class="fas fa-times" aria-hidden="true"></i>
                </button>
              }
            </div>
            @if (task.status === 'downloading') {
              <div class="download-track" role="progressbar" aria-valuemin="0" aria-valuemax="100" [attr.aria-valuenow]="task.percent">
                <span [style.width.%]="task.percent"></span>
              </div>
            }
          </article>
        }
      </div>
    }
  </aside>
}
